import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export function Contact() {
  return (
    <section id="kontakt" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl mb-6 text-gray-900">Kontaktirajte nas</h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Spremni smo odgovoriti na sva vaša pitanja i pomoći vam ostvariti vaše vizije
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="grid grid-cols-2 gap-4 lg:flex lg:flex-col lg:space-y-8 lg:mt-28">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Phone className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-xl text-gray-900">Telefon</h3>
                <a href="tel:+3850921829070" className="text-sm sm:text-base text-gray-400 hover:text-gray-900 duration-300 transition-all">+385 092 182 9070</a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Mail className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-xl text-gray-900">Email</h3>
                <a href="mailto:xemtio1458@gmail.com" className="text-sm sm:text-base text-gray-400 hover:text-gray-900 duration-300 transition-all">xemtio1458@gmail.com</a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-xl text-gray-900">Adresa</h3>
                <a href="https://www.google.com/maps?q=Kneza+Domagoja+7,+Cavtat" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base text-gray-400 hover:text-gray-900 duration-300 transition-all">Kneza Domagoja 7, 20210 Cavtat, Hrvatska</a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Clock className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-xl text-gray-900">Radno vrijeme</h3>
                <p className="text-sm sm:text-base text-gray-400">Pon - Pet: 08:00 - 16:00</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <iframe style={{width: "100%", border: 'none'}} height={600} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d183.61246592316357!2d18.2179038389878!3d42.58077894347872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134c0d990c74e155%3A0xb85e70c677603ceb!2sKneza%20Domagoja%207%2C%2020210%2C%20Cavtat!5e0!3m2!1sen!2shr!4v1704988557779!5m2!1sen!2shr" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Lokacija na google mapsu"></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
